export default {
      id: "icon-contentblockleft-usage",
      viewBox: "0 0 331 331",
      url: __webpack_public_path__ + "icons.svg#icon-contentblockleft",
      toString: function () {
        return this.url;
      }
    }